<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.transfer_settings.form.expiry_days')"
            :is-required="true"
            :error="errors.expiry_days"
            :hint="__('settings.transfer_settings.form.expiry_days_hint')"
        >
            <DInput
                id="expiry_days"
                v-model="form.expiry_days"
                :placeholder="__('settings.transfer_settings.form.expiry_days')"
                :is-valid="isFormFieldValid('expiry_days')"
                type="number"
                min="0"
                max="4294967295"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'TransferForm',
    props: {
        transferSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                expiry_days: this.transferSettings?.expiry_days ?? null

            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>

<style scoped>

</style>
